import React, { useState } from "react";
import AppButton from "../Common/Button";
import ApplyForIbanModal from "../Common/ApplyForIbanModal";

export default function ApplyForIbanButton() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <AppButton className="new-balance-card__cta" onClick={() => setOpen(true)}>
       Link your BSL Account
      </AppButton>

      <ApplyForIbanModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
